import { render, staticRenderFns } from "./bannerdetails.vue?vue&type=template&id=ef20267c&scoped=true&"
import script from "./bannerdetails.vue?vue&type=script&lang=js&"
export * from "./bannerdetails.vue?vue&type=script&lang=js&"
import style0 from "./bannerdetails.vue?vue&type=style&index=0&id=ef20267c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef20267c",
  null
  
)

export default component.exports